import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToContact = () => {
  const location = useLocation();

  const scrollToContact = useCallback((e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }

    // Wenn wir nicht auf der Startseite sind, navigiere zur Startseite mit Anker
    if (location.pathname !== '/') {
      window.location.href = '/#kontakt';
      return;
    }

    // Der Abstand zum Header kommt aus `scroll-margin-top` in index.css
    document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
  }, [location.pathname]);

  return scrollToContact;
};
